import { render, staticRenderFns } from "./DealerOrders.vue?vue&type=template&id=331afd1c&scoped=true"
import script from "./DealerOrders.vue?vue&type=script&lang=js"
export * from "./DealerOrders.vue?vue&type=script&lang=js"
import style0 from "./DealerOrders.vue?vue&type=style&index=0&id=331afd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331afd1c",
  null
  
)

export default component.exports